import { Drawer, DrawerBody, DrawerContent, DrawerTrigger } from '@cobliteam/ui/components';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import AppInfo from '../../../../../../AppInfo/AppInfo';
import ShineBorder from '../../../../../../border/ShineBorder';

const DrawerPageInfo = ({ supportUID }: { supportUID: string }) => {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button variant='ghost' color='default' size='sm' className='relative overflow-hidden'>
          <Icon name='info' />
          <ShineBorder shineColor={['#E0E0E0', '#E0E0E0', '#A07CFE', '#FE8FB5', '#FFBE7B', '#E0E0E0']} borderWidth={2} />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerBody className='flex h-full flex-1 flex-col px-0 py-2'>
          <AppInfo supportUID={supportUID} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerPageInfo;
